
export const mobileMenu = (() => {
	const init = () => {

	}

	return {
		init,
	}
})()
